import { Stack, Typography } from '@mui/material';

interface PendingResultsColumnHeaderProps {
  title: string;
  caption: string;
}

// Header of a results-grid column the processed run has no data for: the
// variable's name with a caption below it saying why the cells are empty.
export const PendingResultsColumnHeader = ({ title, caption }: PendingResultsColumnHeaderProps) => (
  <Stack sx={{ minWidth: 0 }} data-testid="analysis-results-pending-column">
    <Typography variant="body2" noWrap sx={{ fontWeight: 'inherit' }}>
      {title}
    </Typography>
    <Typography variant="caption" color="text.secondary" noWrap>
      {caption}
    </Typography>
  </Stack>
);
